import { generateHTML } from "@tiptap/react";
import { getEditorExtensions } from "./useEditorWithExtensions";
import { formatUtcDateReadableLong } from "../../../../utilities/dateUtils";
import { useAppState } from "../../../../components/App/AppProvider";

type ManualExportItem = {
  label: string;
  link: string;
  id: string;
  jsonStr: string;
  title: string;
  manualTitle: string;
  lastModified: Date | null;
  modifiedBy: {
    userID: string;
    firstName: string;
    lastName: string;
  };
};
type AppInfo = {
  logoPath?: string | null;
  newLogoPath?: string | null;
};

export const exportManualSection = (
  item: ManualExportItem,
  appInfo: AppInfo,
) => {
  const { newLogoPath, logoPath } = appInfo;
  const editorExtensions = getEditorExtensions();
  let html;
  console.log("Manual Title:", item);
  try {
    const parsedContent = item.jsonStr ? JSON.parse(item.jsonStr) : null;
    const htmlContent = parsedContent
      ? generateHTML(parsedContent, editorExtensions)
      : "<i>No content available for this section</i>";

    const lastModified = item.lastModified
      ? formatUtcDateReadableLong(new Date(item.lastModified))
      : "N/A";

    html = `
        <div class="section">
          <p class="section-meta"><strong>Manual:</strong> ${
            item.manualTitle || "N/A"
          }</p>
          <p class="section-meta"><strong>Last Modified:</strong> ${
            lastModified
          }</p>
          <p class="section-meta"><strong>Modified By:</strong> ${
            item.modifiedBy.firstName || ""
          } ${item.modifiedBy.lastName || ""}</p>
          <div class="section-content">${htmlContent}</div>
        </div>
      `;
  } catch (error) {
    console.error("Error parsing JSON:", error);
    html =
      "<div class='section-error'><i>Error loading section content</i></div>";
  }

  return `
      <!DOCTYPE html>
      <html lang="en">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>${item.title || "Document"}</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
            }
            .header {
              display: flex;
              align-items: center;
              margin-bottom: 20px;
            }
            .header img {
              max-height: 72px;
              max-width: 100%;
              margin-right: 20px;
            }
            h1 {
              font-size: 32px;
              margin: 0;
            }
            .section {
              page-break-after: always;
              margin-bottom: 20px;
            }
            .section-title {
              font-size: 24px;
              margin: 0;
            }
            .section-meta {
              font-size: 14px;
              color: #666;
              margin: 0 0 5px 0;
            }
            .section-content {
              margin-top: 10px;
            }
            .section-error {
              color: red;
              font-style: italic;
            }
            .footer {
              margin-top: auto;
              padding-top: 20px;
              border-top: 1px solid #ddd;
              text-align: center;
              font-size: 12px;
              color: #666;
              page-break-inside: avoid;
            }
            .content {
              flex: 1;
            }
          </style>
        </head>
        <body>
        <div class="content">
          <div class="header">
            <img src="${newLogoPath || logoPath}" alt="Logo" />
            <h1>${item.title || "Untitled Document"}</h1>
          </div>
          ${html}
          </div>
        </body>
      </html>
    `;
};
